import { OnInit, EventEmitter, OnDestroy } from '@angular/core';
import { ViewService } from '../services/view.service';
import { ConversationService } from '../services/conversation.service';
import { ConfirmationService } from '../services/confirmation.service';
import { ContextMenuService, ContextMenuComponent } from 'ngx-contextmenu';
import { WorkspaceService } from '../services/workspace.service';
import { Globals } from '../objects/Globals';
import { ThemeSettingService } from '../services/theme-setting.service';
import { DetailService } from '../services/detail.service';
var DocumentOutlineComponent = /** @class */ (function () {
    function DocumentOutlineComponent(viewService, confirmationService, conversationService, globals, detailService, contextMenuService, workspaceService, themeSettingService) {
        var _this = this;
        this.viewService = viewService;
        this.confirmationService = confirmationService;
        this.conversationService = conversationService;
        this.globals = globals;
        this.detailService = detailService;
        this.contextMenuService = contextMenuService;
        this.workspaceService = workspaceService;
        this.themeSettingService = themeSettingService;
        this.documentOutlineList = [];
        this.isDisabled = false;
        this.selectedItem = new EventEmitter();
        this.sub = this.workspaceService.currentParentIdChanged$.subscribe(function (id) {
            if (_this.componentId == id) {
                _this.isBusy = true;
                _this.viewService.getDocumentOutlineCard(id).subscribe(function (result) {
                    _this.isBusy = false;
                    _this.documentOutlineList = JSON.parse(result);
                }, function (error) {
                    _this.isBusy = false;
                });
            }
        });
        this.sub1 = this.detailService.getDetailChanged$.subscribe(function (result) {
            if (result) {
                _this.isDisabled = false;
            }
        });
    }
    Object.defineProperty(DocumentOutlineComponent.prototype, "setComponentId", {
        set: function (id) {
            var _this = this;
            if (id) {
                this.componentId = id;
                this.previousComponentId = this.componentId;
                this.viewService.getDocumentOutlineCard(id).subscribe(function (result) {
                    _this.isBusy = false;
                    _this.documentOutlineList = JSON.parse(result);
                    if (_this.documentOutlineList.length > 0) {
                        if (_this.documentOutlineList.filter(function (x) { return x.ItemId == _this.selectedItemId; }).length == 0) {
                            _this.selectedItemId = _this.documentOutlineList.find(function (x) { return x.ViewOrder == 1; }).ItemId;
                            _this.selectItem(_this.selectedItemId);
                        }
                    }
                }, function (error) {
                    _this.isBusy = false;
                });
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentOutlineComponent.prototype, "setDocumentOutline", {
        set: function (list) {
            this.documentOutlineList = list;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentOutlineComponent.prototype, "setChildComponentId", {
        set: function (id) {
            this.componentId = id;
        },
        enumerable: true,
        configurable: true
    });
    DocumentOutlineComponent.prototype.ngOnInit = function () {
        var themes = this.themeSettingService.getTheme();
        this.loaderConfig = themes;
        this.isBusy = true;
    };
    DocumentOutlineComponent.prototype.ngOnDestroy = function () {
        if (this.sub)
            this.sub.unsubscribe();
        if (this.sub1)
            this.sub1.unsubscribe();
    };
    DocumentOutlineComponent.prototype.pullPopup = function (outline) {
        var _this = this;
        //$event.stopPropagation();
        this.confirmationService.confirm("Add Quick Phrase for " + outline.ItemDisplay, "", ["CANCEL", "OK"], true, "Add Quick Phrase...", true)
            .subscribe(function (respond) {
            if (respond.answer == "OK") {
                _this.conversationService.saveUtteranceForPersonalizedView(respond.inputText, outline.ItemId).subscribe(function (result) {
                    console.log(result);
                });
            }
        });
    };
    DocumentOutlineComponent.prototype.onContextMenu = function ($event, item) {
        this.currentItem = item.ItemId;
        if ($event.button == 0) {
            this.contextMenuService.show.next({
                contextMenu: this.basicMenu,
                event: $event,
                item: item,
            });
        }
        $event.preventDefault();
        $event.stopPropagation();
    };
    DocumentOutlineComponent.prototype.onCloseContextMenu = function () {
        this.currentItem = '';
    };
    DocumentOutlineComponent.prototype.getChild = function (id) {
        var _this = this;
        this.viewService.getDocumentOutlineChildItems(this.componentId, id).subscribe(function (result) {
            _this.documentOutlineList.find(function (x) { return x.ItemId == id; }).ChildList = JSON.parse(result);
        });
    };
    DocumentOutlineComponent.prototype.selectItem = function (id) {
        var _this = this;
        this.selectedItemId = id;
        this.selectedItem.emit(0);
        this.isDisabled = true;
        this.viewService.selectOutlineItem(this.componentId, id).subscribe(function (result) {
            if (result) {
                _this.selectedItem.emit(result);
            }
            else {
                _this.isDisabled = false;
            }
        }, function (error) {
            _this.selectedItem.emit(1);
            _this.isDisabled = false;
        });
    };
    DocumentOutlineComponent.prototype.onSelectedItem = function (id) {
        this.selectedItem.emit(id);
    };
    return DocumentOutlineComponent;
}());
export { DocumentOutlineComponent };
